import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../Services/AppContext';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import DocumentationFileView from './DocumentationFileView';

loadDOMComponent({
	selector: 'react-documentation-file-view',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const documentationFileId = container.getAttribute('documentationFileId');
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<DocumentationFileView
						documentationFileId={documentationFileId}
						userId={userId}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
